import React from 'react'

import styled from 'styled-components'

// import { useWindowSize, useEventListener } from '../../../_helpers'
import {
    colors, 
    devices,
    minDevices,
} from '../../Common'


export const SimpleBlock = ({ pageBlock }) => (
    <TextBlock>
        <div dangerouslySetInnerHTML={{ __html: pageBlock.content }} />
    </TextBlock>
)

const TextBlock = styled.div`
    font-weight: 900;
    font-style: normal;
    /* letter-spacing: 1.5px; */
    font-size: 44px;
    background: ${colors.red};
    color: ${colors.white};
    width: 100%;
    height: 100vh;

    display: flex;
    justify-content: center;
    align-items: center;

    div {
        width: 70%;
        p {
            margin: 0;
        }
    }

    @media ${devices.medium} {
        font-size: 24px;
        height: 90vh;

        div {
            width: 90%;
        }
    }

    @media ${minDevices.small} and ${devices.medium_portrait} {
        height: 60vh;
    }
`
